// src/components/communication/MediaLightboxModal.js
import React, { useState } from "react";
import { X, Download, ZoomIn, ZoomOut, RotateCw } from "lucide-react";
import { useCommunication } from "../../contexts/CommunicationContext";

export default function MediaLightboxModal() {
  const { lightboxData, closeLightbox } = useCommunication();
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);

  if (!lightboxData?.url) return null;

  const handleDownload = async () => {
    try {
      const res = await fetch(lightboxData.url);
      const blob = await res.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = lightboxData.name || "imagem_chat";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (e) {
      window.open(lightboxData.url, "_blank");
    }
  };

  const handleClose = () => {
    setZoom(1);
    setRotation(0);
    closeLightbox();
  };

  return (
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/90 backdrop-blur-md animate-fadeIn"
      onClick={handleClose}
    >
      {/* BARRA SUPERIOR DE FERRAMENTAS */}
      <div
        className="absolute top-4 inset-x-4 flex items-center justify-between z-10 px-4 py-2 rounded-xl bg-slate-900/70 border border-white/10 text-white backdrop-blur"
        onClick={(e) => e.stopPropagation()}
      >
        <span className="text-xs font-semibold text-slate-300 truncate max-w-sm">
          {lightboxData.name || "Visualização de Imagem"}
        </span>

        <div className="flex items-center gap-2">
          <button
            onClick={() => setZoom((prev) => Math.min(prev + 0.25, 3))}
            className="p-1.5 rounded-lg hover:bg-white/10 text-slate-300 hover:text-white transition"
            title="Aumentar Zoom"
          >
            <ZoomIn size={18} />
          </button>
          <button
            onClick={() => setZoom((prev) => Math.max(prev - 0.25, 0.5))}
            className="p-1.5 rounded-lg hover:bg-white/10 text-slate-300 hover:text-white transition"
            title="Diminuir Zoom"
          >
            <ZoomOut size={18} />
          </button>
          <button
            onClick={() => setRotation((prev) => (prev + 90) % 360)}
            className="p-1.5 rounded-lg hover:bg-white/10 text-slate-300 hover:text-white transition"
            title="Girar"
          >
            <RotateCw size={18} />
          </button>
          <div className="w-px h-4 bg-white/20 mx-1" />
          <button
            onClick={handleDownload}
            className="p-1.5 rounded-lg hover:bg-white/10 text-slate-300 hover:text-white transition flex items-center gap-1 text-xs"
            title="Baixar Imagem"
          >
            <Download size={18} />
          </button>
          <button
            onClick={handleClose}
            className="p-1.5 rounded-lg hover:bg-rose-500/20 text-slate-300 hover:text-rose-400 transition ml-2"
            title="Fechar"
          >
            <X size={20} />
          </button>
        </div>
      </div>

      {/* IMAGEM CENTRAL */}
      <div
        className="max-w-[90vw] max-h-[85vh] overflow-hidden flex items-center justify-center p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={lightboxData.url}
          alt={lightboxData.name || "Preview"}
          style={{
            transform: `scale(${zoom}) rotate(${rotation}deg)`,
            transition: "transform 0.2s ease-out",
          }}
          className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-2xl select-none cursor-grab active:cursor-grabbing"
        />
      </div>
    </div>
  );
}
